import { render, staticRenderFns } from "./AscSubtitle.vue?vue&type=template&id=4b09f997&"
import script from "./AscSubtitle.vue?vue&type=script&lang=js&"
export * from "./AscSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports